import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useRelationOverviewStyles } from './useRelationOverviewStyles';
import EventsAttendedTab from './EventsAttendedTab';
import InterestsTabContent from './InterestsTab';
const RelationOverview = ({ relationId, activeTab }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const styles = useRelationOverviewStyles(isSmallScreen);
    return (_jsxs(Box, { sx: styles.container, children: [activeTab === 1 && _jsx(EventsAttendedTab, { relationId: relationId }), activeTab === 2 && _jsx(InterestsTabContent, { relationId: relationId })] }));
};
export default RelationOverview;
